module.exports = __webpack_public_path__ + "static/media/sandwich_goriz.a0ed5b04.png";